import axios from 'axios';
import { useIdentityStore } from '@/store/IdentityStore';
// const baseUrl = 'https://dev-services.nelsonirrigation.com/ndbs/api';
const baseUrl = 'https://services.nelsonirrigation.com/ndbs/api';
const apiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response && error.response.status === 403) {
    // Handle 403 error - example: redirect to login page
    // router.push('/login');
    // Optionally, display a notification to the user
    console.error('Access denied. Redirecting to login.');
    var identityStore = useIdentityStore();
    var refreshToken = identityStore.refresh_token();
    if (refreshToken) {
      identityStore.ssoRefreshToken(refreshToken).then(() => {
        var token = identityStore.access_token();
        if (!token) {
          identityStore.ssoAuthenticate();
        }
      });
    }
  }
});
export default {
  data () {
    return {
      token: null,
    };
  },
  hasToken () {
    return this.token != null;
  },
  setAuthHeader (_token) {
    this.token = _token;
  },
  getFeed () {
    return apiClient.get(baseUrl + '/Announcements', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  getResourcesByTags (tags, pg, limit) {
    const filterTags = [];
    for (let i = 0; i < tags.length; i++) {
      if (i === 0) {
        filterTags.push('tags=' + tags[i]);
      } else {
        filterTags.push('&tags=' + tags[i]);
      }
    }
    const newFilterTags = filterTags.join('');
    return apiClient.get(
      baseUrl +
      '/Resources/tags?' +
      newFilterTags +
      '&page=' +
      pg +
      '&limit=' +
      limit,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  getResources (pg, length, filterVals, searchText, orderBy, orderDescending) {
    // solves issues of how many filterTypes are needed in the api call
    if (filterVals.length > 3) {
      filterVals.pop();
    }
    const filterValues = [];
    for (let i = 0; i < filterVals.length; i++) {
      filterValues.push('&filterTypes=' + filterVals[i]);
    }
    const newFilters = filterValues.join('');
    return apiClient.get(
      baseUrl +
      '/resources/index?page=' +
      pg +
      '&limit=' +
      length +
      newFilters +
      '&searchTxt=' +
      searchText +
      '&orderBy=' +
      orderBy +
      '&orderDescending=' +
      orderDescending,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  async editResource (resource) {
    return await apiClient.post(baseUrl + '/Resources', JSON.stringify(resource), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  deleteResource (resourceId) {
    return apiClient.delete(baseUrl + '/Resources/' + resourceId, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  uploadResource (resourcePk, type, blob) {
    return apiClient.post(
      baseUrl + '/Resources/' + resourcePk + '/upload',
      {
        File: blob,
        type: type,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  fetchLibraryTypes () {
    return apiClient.get(baseUrl + '/Resources/libraryTypes', {
      headers: {
        'Content-Type': 'text/plain',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  fetchLibraryCategories () {
    return apiClient.get(baseUrl + '/Resources/libraryCategories', {
      headers: {
        'Content-Type': 'text/plain',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  getResourceTags (tags, pg, Length) {
    return apiClient.get(
      baseUrl +
      'Resources/tags?tags=' +
      tags +
      'page=' +
      pg +
      '&limit=' +
      Length,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  // setting multiple tags for resources
  addResourceTags (tagId, resources) {
    return apiClient.post(
      baseUrl + '/Tags/' + tagId + '/resources',
      JSON.stringify(resources),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  // removes tags from the resources
  removeResourceTags (tagId, resources) {
    return apiClient.delete(baseUrl + '/Tags/' + tagId + '/resources', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
      data: resources,
    });
  },
  fetchTags () {
    return apiClient.get(baseUrl + '/Tags', {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  createTag (payload) {
    return apiClient.post(baseUrl + '/Tags', JSON.stringify(payload), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  removeTag (tagId) {
    return apiClient.delete(baseUrl + '/Tags/' + tagId, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  fetchGroups () {
    return apiClient.get(baseUrl + '/Groups/find', {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  removeGroup (groupId) {
    return apiClient.delete(baseUrl + '/Groups/' + groupId, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  updateGroup (group) {
    return apiClient.post(baseUrl + '/Groups', JSON.stringify(group), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  getCollections (pg, length, searchText, orderBy, orderDescending) {
    return apiClient.get(
      baseUrl +
      '/resources/collections?page=' +
      pg +
      '&limit=' +
      length +
      '&searchTxt=' +
      searchText +
      '&orderBy=' +
      orderBy +
      '&orderDescending=' +
      orderDescending,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  async fetchResourcesForCollection (cId, page, limit) {
    return apiClient.get(
      baseUrl +
      '/resources/index?cId=' +
      cId +
      '&page=' +
      page +
      '&limit=' +
      limit,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },

  collectionLinkResources (collectionId, resources) {
    return apiClient.put(
      baseUrl + '/Collections/' + collectionId + '/linkResources',
      JSON.stringify(resources),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },

  collectionUnlinkResources (collectionId, resources) {
    return apiClient.put(
      baseUrl + '/Collections/' + collectionId + '/unlinkResources',
      JSON.stringify(resources),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },

  setCollection (collection) {
    return apiClient.post(
      baseUrl + '/Collections',
      JSON.stringify(collection),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  removeCollection (collectionId) {
    return apiClient.delete(baseUrl + '/Collections/' + collectionId, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  addCollectionTags (tagId, collectionId) {
    return apiClient.post(
      baseUrl + '/Tags/' + tagId + '/collections',
      JSON.stringify(collectionId),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  removeCollectionTags (tagId, collectionId) {
    return apiClient.delete(baseUrl + '/Tags/' + tagId + '/collections', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
      data: collectionId,
    });
  },
  async fetchPortalPermissions () {
    const identityStore = useIdentityStore();

    return apiClient.get(
      identityStore.config.authority +
      '/api/subscriptions/scoped?scope=marketing&type=media',
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  },
  // Dealer Editor endpoints
  async getDealers () {
    return await apiClient.get('/cms/dealers', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  async getLocales () {
    return await apiClient.get('/cms/locales', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  async getDealerTerritories () {
    return await apiClient.get('/cms/territories/1', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  async getCountries () {
    return await apiClient.get('/cms/countries', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  async postDealer (dealer) {
    return await apiClient.post('/cms/dealers', dealer, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  async postTerritory (territory) {
    return await apiClient.post('/cms/territories', territory, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  async deleteTerritory (territoryId) {
    return await apiClient.delete('/cms/territories/' + territoryId, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },      
    });
  },
  async deleteDealer (dealerId) {
    return await apiClient.delete('/cms/dealers/' + dealerId, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    });
  },
  async getRegions (localeId) {
    return await apiClient.get('/cms/regions/' + localeId, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
      },
    }); 
  }
};
